import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.common.AddCommentEditor', {
    addCommentPlaceholder: 'Add a comment',
});
